<template lang="pug">
    div.expandCard
        table
            tr

                // Created date
                td {{ $t('fields.createdAt') }}
                td {{ item.createdAt | formattedDate }}

            tr
                // Description
                td {{ $t('fields.description') }}
                td {{ item.description }}

</template>
<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';

    export default {
        filters: {
            formattedDate
        },
        props: {
            item: VueTypes.object.def({})
        }
    };
</script>
